import { StrainIndexRiskEnum } from '@/utils/enum';
import type { Mapper } from '@/core/mapper/base-mapper';
import type { StrainIndexReport } from '@/types/StrainIndex';
import type { GetStrainIndexReportResponseDTO } from '@/core/dto/strain-index';
import { ACCEPTABLE_RISK_RESULT, VERY_HIGH_RISK_RESULT } from '@/utils/constants';

export class StrainIndexReportMapper implements Mapper<StrainIndexReport> {
	constructor(private readonly data: GetStrainIndexReportResponseDTO) {}

	private getResult(): number {
		const riskResultMapper = {
			[StrainIndexRiskEnum.HAZARDOUS]: VERY_HIGH_RISK_RESULT,
			[StrainIndexRiskEnum.SAFE]: ACCEPTABLE_RISK_RESULT
		};

		const leftRisk = this.data?.left_risk as StrainIndexRiskEnum;
		const rightRisk = this.data?.right_risk as StrainIndexRiskEnum;

		const leftResult = riskResultMapper[leftRisk] ?? 0;
		const rightResult = riskResultMapper[rightRisk] ?? 0;

		const result = Math.max(leftResult, rightResult);
		return result;
	}

	toDomain(): StrainIndexReport {
		return {
			...this.data,
			result: this.getResult(),
			left_risk: this.data.left_risk ?? '',
			score_left_rsi: this.data.score_left_rsi ?? 0,
			score_left_borg_scale: this.data.score_left_borg_scale ?? 0,
			score_left_wrist_posture: this.data.score_left_wrist_posture ?? 0,
			score_left_daily_duration: this.data.score_left_daily_duration ?? 0,
			score_left_exertion_duration: this.data.score_left_exertion_duration ?? 0,
			score_left_efforts_per_minute: this.data.score_left_efforts_per_minute ?? 0,
			right_risk: this.data.right_risk ?? '',
			score_right_rsi: this.data.score_right_rsi ?? 0,
			score_right_borg_scale: this.data.score_right_borg_scale ?? 0,
			score_right_wrist_posture: this.data.score_right_wrist_posture ?? 0,
			score_right_daily_duration: this.data.score_right_daily_duration ?? 0,
			score_right_exertion_duration: this.data.score_right_exertion_duration ?? 0,
			score_right_efforts_per_minute: this.data.score_right_efforts_per_minute ?? 0
		};
	}
}

